/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function AddGatewayController($scope, $mdDialog, $state, $stateParams, $document, $q, types, gatewayService, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;

        vm.entity = {};

        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.translations = types.entityTypeTranslations[vm.entityType];

        vm.add = add;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        if ($stateParams.gatewayGroupId) {
            vm.entity.gatewayGroupId = {
                entityType: types.entityType.gateway_group,
                id: $stateParams.gatewayGroupId
            };
        }
        gatewayService.saveGateway(vm.entity).then(function success(entity) {
            vm.entity = entity;
            $scope.theForm.$setPristine();
            $mdDialog.hide();
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/gateway/add-gateway.controller.js